<template>
	<!--Solutions -->
	<div class="landing-detail-solutions" v-if="solutionDetail.elements">

		<hero :props="solutionDetail.elements" :heroHome="false"></hero>

		<section class="" id="section" :class="{ enhanced : solutionDetail.elements.enhanced_template.value.length>0 }">
			<div class="inside row">
				<div class="container-fluid our-takes" v-if="solutionDetail.elements.our_take_description">
					<div class="inner-content">
						<h2 v-if="solutionDetail.elements.enhanced_template.value.length==0">Our Take</h2>

						<span :class="{ intro_text : solutionDetail.elements.enhanced_template.value.length>0 }" v-html="solutionDetail.elements.our_take_description.value"></span>
					</div>
				</div>
			</div>
		</section>

		<!-- BIG IDEAS -->
		<section id="big-ideas" v-if="solutionDetail.elements.enhanced_template.value.length>0" class="section-block big-ideas-section col-xs-12 no-gutters" v-in-viewport="">
			<div class="inside row">
				<div class="inner-content">
					<h2 class="text-center" v-in-viewport="">
						Shouldn’t you expect big execution, too?
					</h2>

					<div class="row">
						<div class="col-md-12">
							<p class="text-center">At Marcus Thomas, we’re about creating value, not messages; experiences, not just ads. Take a look at some other examples of our work in this area.</p>
						</div>
					</div>

					<div class="row icons">
						<div class="col-sm-3 area">
							<div class="inner-icons">
								<div class="icon-container" v-in-viewport="">
									<img src="/dist/ux-design.svg" />
								</div>
								<div class="label"><span>User Experience Design</span></div>
								<div class="info">
									<ul>
										<li>Customer journey map development</li>
										<li>Experience maps</li>
										<li>Low- and high-fidelity wireframing</li>
										<li>Static and functional prototyping</li>
										<li>Live and web-based UX testing</li>
										<li>Branded User Interface design</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-sm-3 area">
							<div class="inner-icons">
								<div class="icon-container" v-in-viewport="">
									<img src="/dist/web-mobile-dev.svg" />
								</div>
								<div class="label"><span>Enterprise Web & Mobile Development</span></div>
								<div class="info">
									<ul>
										<li>Web and mobile site development</li>
										<li>Custom web and mobile apps</li>
										<li>CMS and eCommerce implementation</li>
										<li>Promotion/content updates, maintenance</li>
										<li>Outsourcing, staff augmentation and managed services</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-sm-3 area">
							<div class="inner-icons">
								<div class="icon-container" v-in-viewport="">
									<img src="/dist/crm-market.svg" />
								</div>
								<div class="label"><span>CRM / Marketing Automation</span></div>
								<div class="info">
									<ul>
										<li>Salesforce Marketing Cloud consulting and implementation</li>
										<li>Salesforce Sales and Service Cloud integrations</li>
										<li>Third-party CRM integrations (MS Dynamics, Sugar CRM)</li>
										<li>Custom Salesforce Marketing Cloud apps</li>
										<li>Custom Salesforce Journey Builder activities</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-sm-3 area">
							<div class="inner-icons">
								<div class="icon-container" v-in-viewport="">
									<img src="/dist/analytics.svg" />
								</div>
								<div class="label"><span>Analytics & Performance Optimization</span></div>
								<div class="info">
									<ul>
										<li>Measurement strategy design</li>
										<li>Website tracking implementation</li>
										<li>End-to-end campaign measurement and reporting</li>
										<li>Cross-channel and multi-touch attribution</li>
										<li>Custom dashboard development in Tableau and Data Studio</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<!-- PARTNERS -->
			<div class="partners-container">
					<img src="/dist/logo-kentico.png" />
					<img src="/dist/acquia.png" />
					<img src="/dist/salesforce.png" />
					<img src="/dist/google-cloud.png" />
			</div>
		</section>

		<!--EXPERTISES -->
		<section class="col-xs-12 no-gutters expertise" id="expertises">
			<div class="inside">
				<div class="container-fluid" v-if="approachs.length">
					<div class="inner-content">
						<h2 id="scrollHere" :class="{ enhanced : solutionDetail.elements.enhanced_template.value.length>0 }">Expertise</h2>
						<div class="accordions" v-if="solutionDetail.elements.columns.value.length!=0" :class="{ 'row' : solutionDetail.elements.columns.value.length!=0 }" >
							<div v-for="approach in approachs" :class="['accordion',{ 'col-md-12' : solutionDetail.elements.columns.value[0].name == '1' },{ 'col-md-6' : solutionDetail.elements.columns.value[0].name == 2 },{ 'col-sm-6 col-md-4' : solutionDetail.elements.columns.value[0].name == 3 }]">
								<h4 class="gtm_Competency-Expand">{{ approach.title.value }} </h4>
								<div class="accordion-content" v-html="approach.description.value"></div>
							</div>
						</div>
						<div v-else class="accordions">
							<div v-for="approach in approachs" class="accordion">
								<h4 class="gtm_Competency-Expand">{{ approach.title.value }} </h4>
								<div class="accordion-content" v-html="approach.description.value"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="content-works container-fluid col-xs-12" id="section" v-if="relatedWorks.length">
			<h2 class="text-center" v-in-viewport="">Related Work</h2>
			<p class="intro_text">{{pageSolution.related_work_description.value}}</p>
			<boxes-wrapper :boxes="relatedWorks" :boxlimit="4" :showViewAll="true"></boxes-wrapper>
		</section>

		<section class="content-articles container-fluid col-xs-12" v-in-viewport="" v-if="relatedArticles.length">
			<h2 class="text-center" v-in-viewport="">Insights, commentary and news</h2>
			<!--<p class="text-center container">{{pageSolution.related_words_description.value}}</p>-->
			<articles-wrapper :boxes="relatedArticles" :isHome="true" :boxlimit="4" :pathRoute="'/words'" :showCategory="true" :showViewAll="true"></articles-wrapper>

		</section>

		<!-- Contact Form  -->
		<contact :contactFormInfo="contactFormInfo"></contact>

		<!--<more-list :title="'More Marcus Thomas Solutions'" :subtitle="pageSolution.more_marcus_thomas_solutions_description.value" :moreList="solutions"></more-list>-->

		<quote v-if="quote" :quoteData="quote"></quote>
	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import boxesWrapperNew from '../components/boxes-wrapper-new.vue';
	import articlesWrapper from '../components/articles-wrapper.vue';
	import quote from '../components/quote.vue';
	import moreList from '../components/more-list.vue';
	import hero from '../components/hero.vue';
	import VueRecaptcha from 'vue-recaptcha';
	import FileSaver from 'file-saver/FileSaver';
	import contactForm from '../components/contact-form-solutions.vue';

	//Svg Icons
	require('../assets/img/agile.svg');
	require('../assets/img/collab.svg');
	require('../assets/img/detail.svg');
	require('../assets/img/ux-test.svg');
	require('../assets/img/analytics.svg');
	require('../assets/img/crm-market.svg');
	require('../assets/img/web-mobile-dev.svg');
	require('../assets/img/ux-design.svg');
	require('../assets/img/plus.svg');

	require('../assets/img/acquia.png');
	require('../assets/img/logo-kentico.png');

	export default{
		name: 'Solution-detail',
		mixins:[apiConnection,seoModule],
		data () {
		   return {
		   	 quote: [],
		     relatedWorks: [],
		     relatedArticles:[],
		     solutionDetail:[],
		     solutions:[],
		     pageSolution:[],
		     approachs:[],
				 contactFormInfo: [],

				 /*
				 contactForm: {
			      recaptchaVerified: false,
			      pleaseTickRecaptchaMessage: '',
						firstname:'',
						lastname:'',
						company: '',
						email: '',
						campaign: '',
						message: '',
						formSubmitted: false,
						checkBoxSelected : true,
						open: false,
						label: 'Get Started'
			   },
				 journeyForm: {
			      recaptchaVerified: false,
			      pleaseTickRecaptchaMessage: '',
						firstname:'',
						lastname:'',
						company: '',
						email: '',
						campaign: '',
						message: '',
						formSubmitted: false,
						open: false,
						label: 'Get Started'
			   },
				 labels : {
 					headline : 'Do you want to learn more?',
 					subheadline: 'We want to hear from you.',
 					buttonLabel: 'GET STARTED'
 					}
					*/
		   }
		 },
		created:function(){
			this.getSolutions(100);
			this.getSolution(false);
			let url = (this.$route.path).split('/');
			this.getSolutionsDetail(url[2]);

		},
		components:{
			'boxes-wrapper':boxesWrapperNew,
			'articles-wrapper':articlesWrapper,
			'quote': quote,
			'more-list': moreList,
			'hero':hero,
			'contact': contactForm
		},
		methods: {
			openWorks: function(){
				let openTab = window.open('/work', '_self');
				openTab.focus();
			},
			openWords: function(){
				let openTab = window.open('/words',  '_self');
				openTab.focus();
			},
			/*
			openJourney() {
				var elem = document.getElementById("your-journey");

				if(this.journeyForm.open==false){
					elem.classList.add("opened");
					elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
						document.getElementById('openJourney').innerHTML='CLOSE';

					setTimeout(function(){
						if (window.screen.width <= 768) {
							document.getElementById("your-journey").scrollIntoView({block: "start", behavior: "smooth"});
						}
						else {
							document.getElementById("your-journey").scrollIntoView({block: "end", behavior: "smooth"});
						}
						window.onresize = function(event) {
							elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
						};
					},300);

				}
				else {
					console.log('s');
					elem.classList.remove("opened");
					elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
					document.getElementById('openJourney').innerHTML='GET STARTED';

				}

				this.journeyForm.open =  !this.journeyForm.open;
	    },
	    markRecaptchaAsVerifiedJourney(response) {
	      this.journeyForm.pleaseTickRecaptchaMessage = '';
	      this.journeyForm.recaptchaVerified = true;
	    },
			markRecaptchaAsVerifiedContact(response) {
			 this.contactForm.pleaseTickRecaptchaMessage = '';
			 this.contactForm.recaptchaVerified = true;
		 },
		  resetForm(scope) {
			 this.$validator.pause();

			 if(scope=='contactForm'){
					 this.contactForm.recaptchaVerified = false;
					 this.contactForm.pleaseTickRecaptchaMessage = '';
					 this.contactForm.firstname = '';
					 this.contactForm.lastname = '';
					 this.contactForm.company = '';
					 this.contactForm.email = '';
					 this.contactForm.message = '';
					 this.contactForm.checkBoxSelected = true;
			}

			if(scope=='journeyForm'){
					this.journeyForm.recaptchaVerified = false;
					this.journeyForm.pleaseTickRecaptchaMessage = '';
					this.journeyForm.firstname = '';
					this.journeyForm.lastname = '';
					this.journeyForm.company = '';
					this.journeyForm.email = '';
					this.contactForm.message = '';
		 }

			this.$validator.errors.clear();
			this.$validator.reset();
			document.getElementById(scope).reset();
		},
	    validateForm(scope) {
				this.$validator.resume();
				const dict = {
				  custom: {
				    'Email': {
				      required: 'This is a required field.',
							email: 'Please enter a validate email address'
				    },
				    'Last Name': {
				      required: 'This is a required field.',
				    },
						'First Name': {
				      required: 'This is a required field.',
				    },
						'Company': {
				      required: 'This is a required field.',
				    }
				  }
				};
				this.$validator.localize('en', dict);
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						//Check scope
						var formData = new FormData(document.getElementById(scope));
						var myForm;
						if(scope=='contactForm'){
							if(formData.get('LEADCF102')!==null || formData.get('LEADCF106')!==null || formData.get('LEADCF109')!==null){
								this.contactForm.checkBoxSelected = true
							}
							else {
								this.contactForm.checkBoxSelected = false
								return true;
							}
						}
						if(scope=='contactForm'){
							myForm = this.contactForm;
							if (!this.contactForm.recaptchaVerified) {
				        this.contactForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
				        return true; // prevent form from submitting
				      }

						}

						if(scope=='journeyForm'){
							myForm = this.journeyForm;
							if (!this.journeyForm.recaptchaVerified) {
				        this.journeyForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
				        return true; // prevent form from submitting
				      }
						}


						this.$http.post ( 'https://crm.zoho.com/crm/WebToLeadForm', formData ).then(function (response) {
					    // success actions
							if(response.statusText=="OK"){
								myForm.formSubmitted = true;
								this.resetForm(scope);
								console.log('x');

								if(scope=='journeyForm'){
									  this.$http.get('/CX2-client.pdf',{responseType: 'arraybuffer'}).then((response) => {
										  var newBlob = new Blob([response.data], {type:"application/pdf"})
											FileSaver.saveAs(newBlob, "CX2-client-experience-drives-customer-experience.pdf");
										})
								}
							}
					  });

						return false;

					}
				});
	    },
			*/
		},
		mounted: function() {
			setTimeout(function(){
				let accordion = document.querySelectorAll('.accordion');
			}, 1000);


			setTimeout(function(){
			    $('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);


		}
	}
</script>



// WEBPACK FOOTER //
// SolutionDetail.vue?09eafe12